var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHfaGraphWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 601.791 143.687",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 66",
    d: "M1.00006 88.9605C12.4711 87.9799 28.0347 88.9605 58.674 98.7659C76.7314 104.545 87.4149 124.914 102.597 124.914C117.778 124.914 125.193 82.1706 147.844 98.7659C163.457 110.205 176.521 157.599 191.179 137.987C214.919 106.222 223.999 82.4235 236.426 67.7154C246.642 55.6239 262.235 21.9569 278.805 21.9569C298.242 21.9569 312.2 64.0795 327.875 67.7154C344.086 71.4756 356.553 57.9105 372.485 57.9105C388.417 57.9105 394.79 79.612 413.59 108.571C428.884 129.816 434.56 129.816 455.65 129.816C472.538 129.816 484.647 108.571 500.897 108.57C518.104 108.57 536.585 111.584 546.781 111.584C556.978 111.584 563.928 111.584 571.317 85.6946C581.513 49.9656 575.777 75.8892 587.886 12.1549C590.688 -2.59471 600.791 1.53094 600.791 1.53094",
    stroke: "var(--stroke-0, #B930A8)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHfaGraphWave2);
export default __webpack_public_path__ + "static/media/hfa_graph_wave2.9f43300a36758a5547967f5fb3ecb38e.svg";
export { ForwardRef as ReactComponent };